import { defaultTheme } from "@getgrover/ui";
import type { DefaultTheme } from "styled-components";

import { screens } from "./screens";

const theme: DefaultTheme = {
  ...defaultTheme,
  screens,
  globalMaxWidth: "1600px",
};

export { theme };
